import { useSelector } from "react-redux";
import { NavLink } from "react-router";

import Avatar from "@/design/components/Avatar";
import useAccessibleColors from "@/utils/hooks/useAccessibleColors";

import { Card, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

import ActivityBadge from "../components/ActivityBadge";
import ActiveCalls from "./ActiveCalls";

function UserCard({ activeUserList, allCalls, user }) {
  const auth = useSelector((state) => state.auth);
  const colors = useAccessibleColors();

  const isInteractive = auth.accessLevel <= 3;

  const activeUser = activeUserList.findIndex((_user) => _user.username === user.username) >= 0;
  const activeCalls = allCalls.filter((call) => call.caller === user.username || call.callee === user.username);

  let badgeColor = activeUser ? colors.green : colors.grey;
  let badgeActive = false;

  if (activeCalls.length) {
    badgeColor = colors.amber;

    // Use the active animation when being called or when on hold
    badgeActive = activeCalls.find(
      (_call) => _call.method === "INVITE" || (_call.method === "ACK" && _call.onHold === "true"),
    );
  }

  return (
    <Card key={user.id} sx={{ gridRow: `${activeCalls.length + 2} span` }}>
      <List sx={{ gap: 0 }}>
        <ListItem disablePadding={isInteractive}>
          {isInteractive ? (
            <ListItemButton component={NavLink} to={`../call-flow/users/${user.id}`} sx={{ borderRadius: 0 }}>
              <ListItemAvatar>
                <ActivityBadge color={badgeColor} active={badgeActive}>
                  <Avatar text={user.name} />
                </ActivityBadge>
              </ListItemAvatar>
              <ListItemText primary={user.name} secondary={user.exten} />
            </ListItemButton>
          ) : (
            <>
              <ListItemAvatar>
                <ActivityBadge color={badgeColor} active={badgeActive}>
                  <Avatar text={user.name} />
                </ActivityBadge>
              </ListItemAvatar>
              <ListItemText primary={user.name} secondary={user.exten} />
            </>
          )}
        </ListItem>
        {activeCalls.length >= 1 && (
          <List sx={{ gap: 0 }}>
            <ActiveCalls user={user} activeCalls={activeCalls} />
          </List>
        )}
      </List>
    </Card>
  );
}

UserCard.propTypes = {
  activeUserList: PropTypes.array,
  allCalls: PropTypes.array,
  user: PropTypes.object,
};

export default UserCard;
